import { useRef } from 'react'
import { Link } from 'react-router'
import logo from './logo.svg'

// モバイル用のヘッダー。デスクトップでは右カラムのDesktopSidebarがナビを担う
export const HeaderNav: React.FC = () => {
  const checkbox = useRef<HTMLInputElement>(null)

  const closeMenu = () => {
    if (checkbox.current) {
      checkbox.current.checked = false
    }
  }

  return (
    <header className="group sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray/30 lg:hidden">
      <div className="w-full px-6 h-14 flex items-center justify-center">
        <a href="/">
          <img src={logo} alt="FLOWER" className="w-32" />
        </a>
      </div>
      <div className="absolute top-0 right-0 h-14 w-14 flex items-center justify-center">
        <label htmlFor="rose-nav-toggle" className="text-main cursor-pointer" aria-label="メニュー">
          <svg
            className="group-has-[input:checked]:hidden"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          >
            <line x1="3" y1="7" x2="21" y2="7" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="17" x2="21" y2="17" />
          </svg>
          <svg
            className="hidden group-has-[input:checked]:block"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          >
            <line x1="6" y1="6" x2="18" y2="18" />
            <line x1="6" y1="18" x2="18" y2="6" />
          </svg>
          <input type="checkbox" id="rose-nav-toggle" hidden ref={checkbox} />
        </label>
      </div>
      <div className="grid grid-rows-[0fr] group-has-[input:checked]:grid-rows-[1fr] transition-[grid-template-rows] duration-200 ease-in-out">
        <div className="overflow-hidden bg-white">
          <div className="px-6 py-6 space-y-4 text-sm border-t border-gray/30">
            <a href="roses" className="block text-main" onClick={closeMenu}>
              バラのセレクト
            </a>
            <a href="#pricing" className="block text-main" onClick={closeMenu}>
              プラン・料金
            </a>
            <a href="#vases" className="block text-main" onClick={closeMenu}>
              セット花器
            </a>
            <a href="#about" className="block text-main" onClick={closeMenu}>
              私たちについて
            </a>
            <a href="#faq" className="block text-main" onClick={closeMenu}>
              よくある質問
            </a>
            <Link reloadDocument to="/subscription/rose/mypage" className="block text-main" onClick={closeMenu}>
              マイページ
            </Link>
          </div>
        </div>
      </div>
    </header>
  )
}
